module.exports = __webpack_public_path__ + "112321d0d2e682dfdd0864320c10caa4.svg";